import * as types from 'modules/checklists/actionTypes';
import type { DetailedChecklistIsReadyAction } from 'modules/checklists/types';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

export type ChecklistUiDetailsIsReadyReducer = boolean;

const initialState: ChecklistUiDetailsIsReadyReducer = false;

const setIsReady = (
  _: ChecklistUiDetailsIsReadyReducer,
  { payload: isReady }: DetailedChecklistIsReadyAction
): ChecklistUiDetailsIsReadyReducer => isReady;

const reset = (): ChecklistUiDetailsIsReadyReducer => false;

export default createReducer(initialState, {
  [types.APPLICATION_IS_READY]: setIsReady,
  [LOCATION_CHANGE]: reset,
});
